export interface MainSpeaker {
  id: number;
  name: string;
  nameEn: string;
  role: string;
  roleEn: string;
  image: string;
  description: string;
  descriptionEn: string;
  country: string;
  countryEn: string;
  link: string | null;
}

export const mainSpeakers: MainSpeaker[] = [
  {
    id: 1,
    name: "Анастасия\nСемянникова",
    nameEn: "Anastasia\nSemyannikova",
    role: "Основатель ABASCHOOL\nПреподаватель, продуктолог, супервизор",
    roleEn: "Founder of ABASCHOOL\nInstructor, Product Specialist, Supervisor",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/fc6cb1c4a0d42ab856bff7ce0056760e.jpg/s/500x/a/47075/sc/327",
    description:
      "Поведенческий аналитик с международными сертификациями ВСВА, IBA, 6 lvl FTF, специалист по альтернативной коммуникации, магистр психологии.",
    descriptionEn:
      "Behavior analyst with international certifications BCBA, IBA, 6 lvl FTF, specialist in augmentative and alternative communication, Master of Psychology.",
    country: "Литва",
    countryEn: "Lithuania",
    link: "https://aba-school.ru/staff",
  },
  {
    id: 2,
    name: "Валентина\nМинакова",
    nameEn: "Valentina\nMinakova",
    role: "Партнер сертифицированной международной программы подготовки IBA. Спикер Модуля 4",
    roleEn: "Partner of the IBA Certified International Training Program. Module 4 Speaker",
    image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/e07ebdb4c3b61ecb75048720a79f56c5.jpg/s/500x/a/47075/sc/241",
    description:
      "Поведенческий специалист с международной сертификацией IBA, магистр психологии, директор сети АВА-центров Валентины Минаковой, партнер ЦПА (Центра помощи аутизма).",
    descriptionEn:
      "Behavior specialist with IBA international certification, Master of Psychology, director of the Valentina Minakova ABA center network, partner of the Center for Autism Support (CAS).",
    country: "Россия",
    countryEn: "Russia",
    link: null,
  },
  {
    id: 3,
    name: "Валентина\nАнтонович",
    nameEn: "Valentina\nAntonovich",
    role: "Спикер Модуля 2, ведущая вебинаров, консультант Родительского Тренинга",
    roleEn: "Module 2 Speaker, Webinar Host, Parent Training Consultant",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/da2b100499a260b7cbd96c421c5e7aab.png/s/500x/a/47075/sc/268",
    description:
      "Поведенческий аналитик с международной сертификацией IBA, CBA-S, магистр в области начального инклюзивного образования.",
    descriptionEn:
      "Behavior analyst with IBA, CBA-S international certifications, Master's degree in Primary Inclusive Education.",
    country: "Беларусь",
    countryEn: "Belarus",
    link: null,
  },
  {
    id: 4,
    name: "Даниил\nГерасименко",
    nameEn: "Daniil\nGerasimenko",
    role: "Соведущий АВА-курса CEU «Электронные Программы»",
    roleEn: "Co-host of the ABA CEU Course \"Electronic Programs\"",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/b615b88c11d0a78d198b32fe923150e3.png/s/500x/a/47075/sc/93",
    description:
      "Поведенческий специалист, АВА-куратор, разработчик современных Электронных Программ и технических приложений для работы в рамках АВА, педагог-психолог, сенсорно-интегративный логопед, руководитель АВА-центра.",
    descriptionEn:
      "Behavior specialist, ABA supervisor, developer of modern Electronic Programs and technical tools for ABA practice, educational psychologist, sensory integration speech therapist, ABA center director.",
    country: "Россия",
    countryEn: "Russia",
    link: null,
  },
  {
    id: 5,
    name: "Екатерина\nКрылова",
    nameEn: "Ekaterina\nKrylova",
    role: "Спикер цикла вебинаров по АСТ (Терапии Принятия и Ответственности)",
    roleEn: "Speaker for the ACT (Acceptance and Commitment Therapy) Webinar Series",
    image: "https://fs-thb01.getcourse.ru/fileservice/file/thumbnail/h/e51cbdd97c94e64990bd8e13a314f620.jpg/s/500x/a/47075/sc/199",
    description:
      "Поведенческий аналитик с международной сертификацией ВСВА, магистр, выпускница Florida Tech, супервизор.",
    descriptionEn:
      "Behavior analyst with BCBA international certification, Master's degree, Florida Tech graduate, supervisor.",
    country: "США",
    countryEn: "USA",
    link: null,
  },
  {
    id: 6,
    name: "Юлиана\nПьянкова",
    nameEn: "Yuliana\nPyankova",
    role: "Спикер Модулей 5 и 6 сертифицированной международной программы подготовки IBA и ведущая CEU вебинаров",
    roleEn: "Modules 5 & 6 Speaker of the IBA Certified International Training Program and CEU Webinar Host",
    image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/83c861acf92a928165dcd73f222a331e.jpg/s/500x/a/47075/sc/144",
    description:
      "Психолог. Поведенческий специалист. Сертифицированный терапевт ESDM. ACT-терапевт. Коуч родителей в раннем вмешательстве.",
    descriptionEn:
      "Psychologist. Behavior specialist. Certified ESDM therapist. ACT therapist. Parent coach in early intervention.",
    country: "Латвия",
    countryEn: "Latvia",
    link: null,
  },
  {
    id: 7,
    name: "Вера\nЕрмолова",
    nameEn: "Vera\nErmolova",
    role: "Спикер Модуля 5 сертифицированной международной программы подготовки IBA, Спикер Родительского тренинга.",
    roleEn: "Module 5 Speaker of the IBA Certified International Training Program, Parent Training Speaker.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/8db61f411f0c9e0eda9e29a76e0a5b83.JPG/s/500x/a/47075/sc/289",
    description:
      "Поведенческий специалист уровня BCaBA, специалист по инклюзивным процессам и альтернативной коммуникации, специальный психолог.",
    descriptionEn:
      "BCaBA-level behavior specialist, inclusive education and augmentative communication specialist, special education psychologist.",
    country: "Австралия",
    countryEn: "Australia",
    link: null,
  },
];

export interface GuestSpeaker {
  id: number;
  name: string;
  country: string;
  countryEn: string;
  title: string;
  titleEn: string;
  description: string;
  descriptionEn: string;
  image: string;
}

export const guestSpeakers: GuestSpeaker[] = [
  {
    id: 1,
    name: "Lera Vlasova",
    country: "Сингапур",
    countryEn: "Singapore",
    title: "Поведенческий аналитик с международными сертификациями ВСВА, IBA, а также CВA-S, работает в школе Сингапура с детьми с особенностями, блогер",
    titleEn: "Behavior analyst with BCBA, IBA, and CBA-S international certifications, works in a Singapore school with children with special needs, blogger",
    description: "Ведущий вебинара CEU по теме работы с детьми с РАС с высоким уровнем навыков",
    descriptionEn: "CEU webinar host on working with high-functioning children with ASD",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 2,
    name: "Anastasia Yun",
    country: "США",
    countryEn: "USA",
    title: "Поведенческий аналитик с международной сертификацией ВСВА, кандидат наук, преподаватель курсов по АВА, одобренных IBAO, основа ABA&Psy.",
    titleEn: "Behavior analyst with BCBA international certification, PhD candidate, IBAO-approved ABA course instructor, co-founder of ABA&Psy.",
    description: "Ведущий вебинара CEU по теме использования карточек ответов в групповом формате.",
    descriptionEn: "CEU webinar host on the use of response cards in group settings.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 3,
    name: "Lev Tolkachev",
    country: "Кипр",
    countryEn: "Cyprus",
    title: "АВА-специалист, издатель «Идёт работа», организатор курсов по Денверской модели раннего вмешательства (ESDM) на русском языке.",
    titleEn: "ABA specialist, publisher of «Idyot Rabota», organizer of Denver Early Start Model (ESDM) courses in Russian.",
    description: "Ведущий бонус-урока про литературу и источники информации.",
    descriptionEn: "Bonus lesson host on literature and information sources.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 4,
    name: "Marina Kuzmitskaya",
    country: "Кипр",
    countryEn: "Cyprus",
    title: "АВА-специалист, логопед, психолог, редактор и переводчик литературы в издательстве «Идёт работа».",
    titleEn: "ABA specialist, speech therapist, psychologist, editor and translator at «Idyot Rabota» publishing.",
    description: "Ведущий бонус-урока про адаптивные и бытовые навыки.",
    descriptionEn: "Bonus lesson host on adaptive and daily living skills.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 5,
    name: "Albert Feygelson",
    country: "Израиль",
    countryEn: "Israel",
    title: "Ведущий открытого вебинара про работу с детьми с СДВГ.",
    titleEn: "Host of an open webinar on working with children with ADHD.",
    description: "АВА-специалист, психолог, педагог, основатель направления «Отцы и дети», папа ребенка с СДВГ, автор книг по работе с детьми с СДВГ.",
    descriptionEn: "ABA specialist, psychologist, educator, founder of the \"Fathers and Children\" program, father of a child with ADHD, author of books on working with ADHD children.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 6,
    name: "Alexandra Malykhina",
    country: "Россия",
    countryEn: "Russia",
    title: "АСТ-терапевт, поведенческий аналитик IBA, клинический психолог, нейропсихолог, супервизор проекта «Инклюзивный наблюдатель» Центра проблем аутизма",
    titleEn: "ACT therapist, IBA behavior analyst, clinical psychologist, neuropsychologist, supervisor of the \"Inclusive Observer\" project at the Center for Autism Issues",
    description: "Ведущий открытого вебинара про эффективное использование гаджетов.",
    descriptionEn: "Host of an open webinar on the effective use of gadgets.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 7,
    name: "Sergei Andreev",
    country: "Россия",
    countryEn: "Russia",
    title: "Ведущий открытого вебинара про эффективное использование гаджетов.",
    titleEn: "Host of an open webinar on the effective use of gadgets.",
    description: "АВА-специалист, психолог, исследователь в области нейрофизиологии, автор и ведущий коммуникативного клуба «КиберNETики».",
    descriptionEn: "ABA specialist, psychologist, researcher in neurophysiology, author and host of the communicative club «CyberNETics».",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 8,
    name: "Karina Ushakova",
    country: "Россия",
    countryEn: "Russia",
    title: "ABA-специалист, куратор, практик, работающий в индивидуальном и групповом форматах",
    titleEn: "ABA specialist, supervisor, practitioner working in individual and group formats",
    description: "Со-ведущий CEU вебинара по теме использования карточек ответов в групповом формате.",
    descriptionEn: "Co-host of the CEU webinar on the use of response cards in group settings.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 9,
    name: "Darya Tokareva",
    country: "Россия",
    countryEn: "Russia",
    title: "Ведущий бонус-урока про развитие речи и коммуникации.",
    titleEn: "Bonus lesson host on speech and communication development.",
    description: "АВА-специалист, магистр в области логопедии, специалист по логомассажу. Практик, сочетающий методы АВА и логопедии в работе с детьми с разными нозологиями.",
    descriptionEn: "ABA specialist, Master's in speech therapy, oral massage specialist. Practitioner combining ABA and speech therapy methods with children of various diagnoses.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 10,
    name: "Anastasia Kosolapova",
    country: "Россия",
    countryEn: "Russia",
    title: "АВА-специалист, специальный психолог, куратор поведенческих программ, выпускница курса Кати Крыловой по АСТ, автор телеграм канала «АКТуально для жизни сейчас»",
    titleEn: "ABA specialist, special education psychologist, behavioral program supervisor, graduate of Katya Krylova's ACT course, author of the Telegram channel «ACTual for Life Now»",
    description: "Приглашенный спикер по обзору АСТ-литературы.",
    descriptionEn: "Guest speaker on an overview of ACT literature.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 11,
    name: "Evgenia Mironova",
    country: "Россия",
    countryEn: "Russia",
    title: "Нейропсихолог, логопед, специалист по сенсорной интеграции, преподаватель курса «Понимание речи». Междисциплинарный практик, работающий с детьми с разными нозологиями.",
    titleEn: "Neuropsychologist, speech therapist, sensory integration specialist, instructor of the «Speech Comprehension» course. Interdisciplinary practitioner working with children of various diagnoses.",
    description: "Ведущий бонус-урока по пониманию речи.",
    descriptionEn: "Bonus lesson host on speech comprehension.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 12,
    name: "Marina Khabibulina",
    country: "Россия",
    countryEn: "Russia",
    title: "Специалист по сенсорной интеграции (СИ) и лечебно-физической культуре (ЛФК), АВА-инструктор. Практик, работающий с детьми с разными нозологиями.",
    titleEn: "Sensory integration and therapeutic physical education specialist, ABA instructor. Practitioner working with children of various diagnoses.",
    description: "Ведущий бонус-урока про сенсорную интеграцию и движение.",
    descriptionEn: "Bonus lesson host on sensory integration and movement.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 13,
    name: "Ilya Rozov",
    country: "Россия",
    countryEn: "Russia",
    title: "Психолог, преподаватель школы «Чистые Когниции», ведущий книжного клуба «Read and ACT», консультант АСТ, ведущий телеграм канала АСТ/ТПО",
    titleEn: "Psychologist, instructor at the «Pure Cognitions» school, host of the «Read and ACT» book club, ACT consultant, Telegram channel host on ACT/RFT",
    description: "Приглашенный спикер на тему «Супервизия АСТ»",
    descriptionEn: "Guest speaker on the topic of \"ACT Supervision\"",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 14,
    name: "Alexandra Rubtsova",
    country: "Россия",
    countryEn: "Russia",
    title: "Магистр в области современных технологий инклюзивного образования лиц с дизонтогенезом, спортивный психолог.",
    titleEn: "Master's in modern inclusive education technologies for individuals with dysontogenesis, sports psychologist.",
    description: "Ведущий бонус-урока про психологическую поддержку и эмоциональную стабильность.",
    descriptionEn: "Bonus lesson host on psychological support and emotional stability.",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
  {
    id: 15,
    name: "Fedor Filatov",
    country: "Россия",
    countryEn: "Russia",
    title: "АВА-специалист, папа 2 детей, со-ведущий родительского тренинга",
    titleEn: "ABA specialist, father of 2 children, co-host of parent training",
    description: "",
    descriptionEn: "",
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/7910be341bcbaa8b2700d4ee236b4ddd.png/s/500x/a/47075/sc/315",
  },
];

export interface StudentAchievement {
  id: number;
  label: string;
  labelEn: string;
  image: string;
}

export const studentAchievements: StudentAchievement[] = [
  { id: 1, label: "Разговаривать", labelEn: "Speak", image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/5a207ad2954c9bba9d1eeb10bc792da8.png/s/500x/a/47075/sc/328" },
  { id: 2, label: "Формулировать свои мысли", labelEn: "Express their thoughts", image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/bdbd89db7bd6d5d187e1a7307272b721.png/s/500x/a/47075/sc/242" },
  { id: 3, label: "Сообщать о боли", labelEn: "Communicate pain", image: "https://fs-thb01.getcourse.ru/fileservice/file/thumbnail/h/df7cef78083e4726dbf7d73a6c415a46.png/s/500x/a/47075/sc/257" },
  { id: 4, label: "Пользоваться туалетом", labelEn: "Use the toilet independently", image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/43f77d96421b9c8f903030ca4b7f4165.png/s/500x/a/47075/sc/55" },
  { id: 5, label: "Идти по улице вместе, не убегать", labelEn: "Walk together without running away", image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/40f09592f106912f2ed98e603e31d541.png/s/500x/a/47075/sc/3" },
  { id: 6, label: "Одеваться самостоятельно", labelEn: "Dress independently", image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/0f1bfd3048f8ce1c1ce0bcc91c6b5efa.png/s/500x/a/47075/sc/467" },
  { id: 7, label: "Самостоятельно проводить досуг", labelEn: "Engage in independent leisure", image: "https://fs-thb01.getcourse.ru/fileservice/file/thumbnail/h/08ef165921af8a7bdf50ac29ea9c2017.png/s/500x/a/47075/sc/238" },
  { id: 8, label: "Играть в новые игры", labelEn: "Play new games", image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/51702fc25150812c74aee11bdb4c4f29.png/s/500x/a/47075/sc/127" },
  { id: 9, label: "Спокойно ждать", labelEn: "Wait calmly", image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/70b1d3b342f9e6acb190304520f3b59e.png/s/500x/a/47075/sc/130" },
  { id: 10, label: "Есть новую пищу", labelEn: "Try new foods", image: "https://fs-thb01.getcourse.ru/fileservice/file/thumbnail/h/97ee4c9269ff370f165482e8550d774b.png/s/500x/a/47075/sc/80" },
  { id: 11, label: "Самостоятельно пользоваться ложкой и вилкой", labelEn: "Use a spoon and fork independently", image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/6e84796a9b4c4dbd0eb5b80ba1d26fcb.png/s/500x/a/47075/sc/383" },
  { id: 12, label: "Готовить себе обед", labelEn: "Prepare their own meal", image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/855cf440a5c13a484a6355d6d1cd8f0a.png/s/500x/a/47075/sc/186" },
  { id: 13, label: "Понимать речь", labelEn: "Understand spoken language", image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/9f7ee61e5a43f49557ab2764a2249de1.png/s/500x/a/47075/sc/159" },
  { id: 14, label: "Справляться со своими истериками", labelEn: "Manage their own meltdowns", image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/86787d62ade231993d6605126bd5584d.png/s/500x/a/47075/sc/19" },
  { id: 15, label: "Сотрудничать", labelEn: "Cooperate", image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/19f7ccdf92fdf6c6259aa64d7399d762.png/s/500x/a/47075/sc/272" },
];

export interface Partner {
  id: number;
  image: string;
  description: string;
  descriptionEn: string;
}

export const partners: Partner[] = [
  {
    id: 1,
    image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/5aa82fc86f8a8233db338ac582079af7.png/s/500x/a/47075/sc/204",
    description: "Коллектив психологов, педагогов, медицинских экспертов и исследователей в области нейронаук. Специалисты используют инновационный VR-подход к терапии, который позволяет эффективно развивать социальные навыки и эмпатию в безопасной виртуальной среде.",
    descriptionEn: "A team of psychologists, educators, medical experts, and neuroscience researchers. Specialists use an innovative VR-based therapy approach that effectively develops social skills and empathy in a safe virtual environment.",
  },
  {
    id: 2,
    image: "https://fs-thb01.getcourse.ru/fileservice/file/thumbnail/h/2ce31e044cdc182482063a6ffec17cf9.png/s/500x/a/47075/sc/236",
    description: "Объединение родителей детей с РАС, которое воплощает в жизнь инклюзивные проекты и помогает с адаптацией в разных сферах жизни людям с расстройствами аутистического спектра любого возраста.",
    descriptionEn: "An association of parents of children with ASD that brings inclusive projects to life and helps people of all ages with autism spectrum disorders adapt across various areas of life.",
  },
  {
    id: 3,
    image: "https://fs-thb02.getcourse.ru/fileservice/file/thumbnail/h/2f68d7c0dc83ee30e673e134eea01c84.png/s/500x/a/47075/sc/240",
    description: "Строительный холдинг в Уральском регионе, поддерживающий инклюзивные и образовательные проекты. Именно Атомстройкомплекс любезно предоставил локации для съемок родительского курса ABASCHOOL.",
    descriptionEn: "A construction holding company in the Ural region supporting inclusive and educational projects. Atomstroycomplex generously provided filming locations for the ABASCHOOL parent course.",
  },
  {
    id: 4,
    image: "https://fs-thb03.getcourse.ru/fileservice/file/thumbnail/h/18041ebde49a06697ae760a4d0871e3d.png/s/500x/a/47075/sc/144",
    description: "Сообщество для специалистов редкой, но важной профессии — тьюторов, работающих с детьми с ОВЗ, с инвалидностью. Обучение, информирование и просвещение как специалистов, так и родителей по темам инклюзивного образования.",
    descriptionEn: "A community for professionals in the rare but vital role of tutors working with children with disabilities. Training, informing, and educating both specialists and parents on inclusive education topics.",
  },
];
